function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#4A4A4A",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.82 20.18h3.36v1.64h-5v-10h-2.5L11 8.5l3.32 3.32h-2.5M20.18 11.82h-3.36v-1.64h5v10h2.5L21 23.5l-3.32-3.32h2.5"
}))));